// extracted by mini-css-extract-plugin
module.exports = {"root":"ClearentDisclaimer_root__2Aydj","header":"ClearentDisclaimer_header__2SiXr","inner":"ClearentDisclaimer_inner__2vf9u"};